<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Empresa</h4>
      </div>
      <div>

        <fg-input name="Nome"
          v-validate="modelValidations.name"
           label="Nome" v-model="model.name"></fg-input>

        <fg-input name="Email" 
          v-validate="modelValidations.email"
          v-if="crud === 'Criar'" label="E-mail" v-model="model.email"></fg-input>

          <fg-input name="Email" 
          v-validate="modelValidations.email"
          v-if="crud === 'Editar'" readonly label="E-mail" v-model="model.email"></fg-input>

          <fg-input
            v-if="this.ciaID"
            name="Matriz"
            label="Empresa Matriz">

            <el-select class=""
                        size="large"
                        style="width: 100%"
                        placeholder="Selecione a empresa Matriz"
                        v-model="model.parent_company">
              <el-option v-for="option in $store.state.parent.matrizes"
                          class=""
                          :value="option.id"
                          :label="option.name"
                          :key="option.id">
              </el-option>
            </el-select>
          </fg-input>

        
          <!-- <fg-input
            name="company"
            label="Sistema de vendas">

            <el-select class=""
                        size="large"
                        style="width: 100%"
                        placeholder="Selecione o sistema de venda à ser utilizado"
                        v-model="model.payment_methods">
              <el-option v-for="option in vmSystem"
                          class=""
                          :value="option.value"
                          :label="option.label"
                          :key="option.id">
              </el-option>
            </el-select>
          </fg-input> -->

        <fg-input name="url" label="URL de notificação" v-model="model.notification_url"></fg-input>

        <fg-input
          name="Token"
          label="Token"
          v-model="model.payment_token"
        ></fg-input>
        <fg-input
          name="Aplicativo ID"
          label="Aplicativo ID"
          v-model="model.payment_id"
        ></fg-input>

          <el-checkbox @input="confirm()" 
            v-if="ciaID"
            v-model="model.is_active">Empresa Ativa</el-checkbox>
          <br>
          <el-checkbox  v-model="paymentSystem">Possui máquina com pagamento via MercadoPago</el-checkbox>
        
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Checkbox } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
  },
  mounted() {
    // this.$store.dispatch("sales/list")
    const ciaID = localStorage.getItem('imachCiaID')
    this.ciaID = ciaID
    if (ciaID) {
      this.ciaID = true
    } else {
      this.ciaID = false
    }
    this.$store.dispatch("parent/list").catch(err => console.log(err))
    if (this.$route.params.id) {
      this.$store.dispatch("company/get", {id: this.$route.params.id}).then(data => {
        if (data.payment_methods === 'MP') {
          this.paymentSystem = true
        } else {
          this.paymentSystem = false
        }
        this.model = data
      });
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
  },
  computed: {
    sales() {
      return this.$store.state.sales.sales;
    }
  },
  data() {
    return {
      crud: "Editar",
      featureFlag: [],
      ciaID: false,
      paymentSystem: false,
      vmSystem: [ // {value: null, label: 'Nenhum'},
                  {value: 'VM', label: 'VM Pay'},
                  // {value: 'VP', label: 'Vend Pago'},
                  {value: 'MP', label: 'Mercado Pago'},
                 //  {value: 'OT', label: 'Outro'}
                  ],
      model: {
        name: '',
        payment_methods: '',
        notification_url: ''

      },
      modelValidations: {
        email: {
          required: true
        },
        name: {
          required: true
        },
      }
    };
  },
  methods: {
    localeDate(date) {
      const d = new Date(date);
      return d.toLocaleString("pt-BR");
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyAlert() {
      this.$notify({
        message: "Opa!</br>Preencha pelo menos os campos de nome e e-mail!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "warning"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (this.paymentSystem) {
          this.model.payment_methods = 'MP'
        } else {
          this.model.payment_methods = 'VM'
        }
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("company/create", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/companies`);
            });
        } else if (isValid && this.crud === "Editar") {
          console.log("customer", this.model);
          this.$store
            .dispatch("company/update", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/companies`);
            });
        } else {
          this.notifyAlert();
        }
      });
    },
    confirm () {
      if (!this.model.is_active) {
        swal.fire({
          title: "Tem certeza?",
          text: `Você está prestes a bloquear a empresa. Todos os endpoints serão bloqueados!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim, bloqueie!",
          cancelButtonText: "Cancelar",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            swal.fire({
              title: "Pronto!",
              text: `Empresa será bloqueada ao salvar.`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            this.model.is_active = false
          } else if (result.dismiss === "cancel") {
            swal.fire({
              title: "Ops!",
              text: `Empresa não será bloqueada ao salvar.`,
              icon: "error",
              confirmButtonClass: "btn btn-info btn-fill",
              buttonsStyling: false
            });
            this.model.is_active = true
          }
        });
      }
    },
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
